module.exports = __webpack_public_path__ + "img/adverport-logo-min.878bf1c9.png";